
export default function ExpertSection() {
  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Experto en Cirugía Robótica y Láser
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Especialista certificado con formación internacional en las técnicas más avanzadas 
            de cirugía robótica urológica y tratamientos láser de precisión.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <img 
              src="https://static.readdy.ai/image/f15b91f1c882dc85fb9b8fcd7db718c1/a52d6be6ac50ee3864cba61d76f1e91a.jpeg"
              alt="Dr. Especialista en Cirugía Robótica"
              className="w-full h-96 object-cover object-top rounded-2xl shadow-2xl"
            />
          </div>
          
          <div className="space-y-8">
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 rounded-full flex items-center justify-center mr-4" style={{ backgroundColor: '#20C6B2' }}>
                  <i className="ri-microscope-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Tecnología de Vanguardia</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Utilizo el sistema robótico da Vinci Xi, la tecnología más avanzada en cirugía 
                mínimamente invasiva, que permite precisión milimétrica y mejores resultados 
                para mis pacientes.
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-heart-pulse-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Precisión Quirúrgica</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Cada procedimiento se realiza con la máxima precisión, minimizando el trauma 
                quirúrgico y acelerando la recuperación del paciente con resultados superiores.
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 rounded-full flex items-center justify-center mr-4" style={{ backgroundColor: '#1A1A1A' }}>
                  <i className="ri-shield-check-line text-2xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900">Seguridad Garantizada</h3>
              </div>
              <p className="text-gray-600 leading-relaxed">
                Protocolos de seguridad internacionales y tecnología láser de última generación 
                para tratamientos seguros y efectivos con mínimas complicaciones.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
